import useLscMultiSelect from './UseLscMultiSelect';

import MultiSelect from '../MultiSelect';

import global from '../../GlobalStyle.module.css';

const LscMultiSelect = ({ label, name, value, error, message, onChange, filterIds="" }) => {
  const { lscState, options } = useLscMultiSelect(filterIds);

  return lscState.message
    ? <span className={global.LoadingMsg}>{lscState.message}</span>
    : (
      <MultiSelect
        label={label}
        name={name}
        value={value}
        options={options}
        error={error}
        message={message}
        isLoading={lscState.isLoading}
        onChange={onChange} />
    );
};

export default LscMultiSelect;